export const ROUTES = {
  setup: '/setup',
  home: '/home',
  applicationForm: '/application-form',
};
